import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_2 = { class: "list-table-container" }
const _hoisted_3 = { class: "has-text-centered mt-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_breadcrumb, {
        size: "is-large",
        separator: "has-succeeds-separator",
        "aria-label": "breadcrumbs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_breadcrumb_item, { active: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.devices')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'firmware-list' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('firmwares.title')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_table, {
        data: _ctx.deviceList,
        striped: "",
        loading: _ctx.loading.devices,
        "sort-icon": "menu-up",
        "default-sort": "updatedAt",
        "default-sort-direction": "desc",
        onClick: _ctx.handleRowClick
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('devices.noDevices')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_b_table_column, {
            field: "id",
            sortable: "",
            label: _ctx.$t('devices.id')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.id), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "name",
            sortable: "",
            label: _ctx.$t('devices.name')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "model",
            sortable: "",
            label: _ctx.$t('devices.model')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.model), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "model",
            sortable: "",
            label: _ctx.$t('devices.status')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.$t('status.'+props.row.status)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "updatedAt",
            sortable: "",
            label: _ctx.$t('devices.lastConnect'),
            numeric: ""
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(_ctx.$d(new Date(props.row.updatedAt), 'short')), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "loading", "onClick"])
    ])
  ]))
}